<form [formGroup]="stepForm" *ngIf="stepForm">
  <h5 class="nmbcol">{{ "Sellers.Products.BasicInfo" | translate }}</h5>
  <div class="cardbg-white">
    <div class="row">
      <div id="product-name" class="col-md-6 mb-4">
        <app-product-name [fieldObject]="productNameField"
                          [fieldErrors]="formValidator.formErrors"
                          [formControlRef]="convertControls(productNameField.fieldName)"
                          [productType]="productTypeId"
                          [isUpdate]="isUpdate"></app-product-name>
      </div>
      <div id="expiry-date" class="col-md-6 mb-4">
        <app-date-now [fieldObject]="productExpiryDateField"
                      [fieldErrors]="formValidator.formErrors"
                      [formControlRef]="convertControls('Expiry date')"
                      [productType]="productTypeId"
                      [isUpdate]="isUpdate"></app-date-now>
      </div>
      <div id="product-description" class="col-md-6 mb-4">
        <app-text-area [fieldObject]="productDescriptionField"
                      [fieldErrors]="formValidator.formErrors"
                      [formControlRef]="convertControls(productDescriptionField.fieldName)"
                      [productType]="productTypeId"
                      [isUpdate]="isUpdate"></app-text-area>
      </div>
      <div id="after-payment-message" class="col-md-6 mb-4">
        <app-text-area [fieldObject]="afterPaymentMessageField"
                      [fieldErrors]="formValidator.formErrors"
                      [formControlRef]="convertControls('After Payment Message')"
                      [productType]="productTypeId"
                      [isUpdate]="isUpdate"></app-text-area>
      </div>
    </div>

  <div class="row align-items-center mx-0 mb-4" *ngIf="productName === 'Invoice'">
    <div class="col-md-3" id="invoice-label">
      <label> {{'invoice number'}}</label>
    </div>
    <div class="col-md-9" id="invoice-field">
      <app-no-label-text-area [fieldObject]="invoiceNumberField"
                              [fieldErrors]="formValidator.formErrors"
                              [formControlRef]="convertControls('Invoice number')"
                              [productType]="productTypeId"
                              [isUpdate]="isUpdate"></app-no-label-text-area>
    </div>
  </div>
  <!-- <div class="row align-items-center mx-0">
    <div class="col-md-7" id="show-question-label">
      <label>
        {{ 'Sellers.Products.ShowProduct' | translate: { product: 'event', productAr: 'الفعالية' } }}
      </label>
    </div>
    <div class="col-md-5" id="show-question-field">
      <app-no-label-toggle [fieldObject]="showOnShopField"
                           [fieldErrors]="formValidator.formErrors"
                           [formControlRef]="convertControls(showOnShopField.fieldName)"
                           [productType]="productTypeId"
                           [isUpdate]="isUpdate"></app-no-label-toggle>
    </div>
  </div> -->
</div>


<div class="cardbg-white my-3" id="payment-option-container">
  <div class="row align-items-center mx-0">
    <div class="col-md-12" id="payment-options-label">
      <h6>{{ "Sellers.Products.PaymentOptions" | translate }}</h6>
    </div>
    <div class="col-md-12 columcard" id="payment-options-field">
      <app-payment-options [fieldObject]="paymentOptionsField"
                           [fieldErrors]="formValidator.formErrors"
                           [formControlRef]="convertControls('Payment options')"
                           [productType]="productTypeId"
                           [isUpdate]="isUpdate"></app-payment-options>
    </div>
  </div>
</div>

<div class="cardbg-white my-3">
  <div class="row align-items-center mx-0 mb-4" *ngIf="hasCash">
    <div class="col-md-7" id="cash-expiry-label">
      <label>{{ 'Sellers.Products.CashExpiryDuration' | translate }}</label>
    </div>
    <div class="col-md-5" id="cash-expiry-field">
      <app-quick-cash-expirydate [fieldObject]="cashFormField"
                                 [fieldErrors]="formValidator.formErrors"
                                 [formControlRef]="convertControls('cash options')"
                                 [productType]="productTypeId"
                                 [isUpdate]="isUpdate"></app-quick-cash-expirydate>
    </div>
  </div>
  <div class="row align-items-center mx-0 mb-4" *ngIf="hasQasatly">
    <div class="col-md-7">
      <label>{{ 'Sellers.Products.QasatlyDeposit' | translate }}</label>
    </div>
    <div class="col-md-5">
      <app-number [fieldObject]="QasatlyDepositField"
                              [fieldErrors]="formValidator.formErrors"
                              [formControlRef]="convertControls('Do you want Qasatly Deposit?')"
                              [productType]="productTypeId"
                              [isUpdate]="isUpdate"></app-number>
    </div>
  </div>
  <div class="row align-items-center mx-0 mb-4">
    <div class="col-md-7" id="fees-question-label">
      <label>{{ 'Sellers.Products.FeesBuyer' | translate }}</label>
    </div>
    <div class="col-md-5" id="fees-question-field">
      <app-no-label-toggle [fieldObject]="feesOnBuyerField"
                           [fieldErrors]="formValidator.formErrors"
                           [formControlRef]="convertControls('Do you want the fees to be on the buyer?')"
                           [productType]="productTypeId"
                           [isUpdate]="isUpdate"></app-no-label-toggle>
    </div>
  </div>
    <div class="row align-items-center mx-0 mb-4">
      <div class="col-md-7" id="fees-question-label">
        <label>{{ 'Sellers.Products.SplitFees' | translate }}</label>
      </div>
      <div class="col-md-5" id="fees-question-field">
        <app-no-label-toggle [fieldObject]="splitFeesField" [fieldErrors]="formValidator.formErrors"
          [formControlRef]="convertControls('Do you want the fees to be split between buyer and seller?')" [productType]="productTypeId"
          [isUpdate]="isUpdate"></app-no-label-toggle>
      </div>
    </div>
  <div class="row align-items-center mx-0 mb-4">
    <div class="col-md-7" id="fees-question-label">
      <label>{{ 'Sellers.Products.VATSeller' | translate }}</label>
    </div>
    <div class="col-md-5" id="fees-question-field">
      <app-no-label-toggle [fieldObject]="VATOnSellerField"
                           [fieldErrors]="formValidator.formErrors"
                           [formControlRef]="convertControls('Do you want the VAT to be on buyer?')"
                           [productType]="productTypeId"
                           [isUpdate]="isUpdate"></app-no-label-toggle>
    </div>
  </div>
</div>


<div class="cardbg-white my-3">
  <div class="row align-items-center mx-0 mb-4">
    <div class="col-md-7" id="fees-question-label">
      <label>{{ 'Sellers.Products.SendSms' | translate }}</label>
    </div>
    <div class="col-md-5" id="fees-question-field">
      <app-no-label-toggle [fieldObject]="SendSmsField"
                           [fieldErrors]="formValidator.formErrors"
                           [formControlRef]="convertControls('Do you want to send an SMS to the buyer after purchase? with a cost 0.5 EGP')"
                           [productType]="productTypeId"
                           [isUpdate]="isUpdate"></app-no-label-toggle>
    </div>
  </div>

  <div class="row align-items-center mx-0 mb-4">
    <div class="col-md-7" id="fees-question-label">
      <label>{{ 'Sellers.Products.SendWhatsAppMsgAfterTrxToBuyer' | translate: {cost: '0.5'} }}</label>
    </div>
    <div class="col-md-5" id="fees-question-field">
      <app-no-label-toggle [fieldObject]="sendWhatsAppMsgAfterTrxToBuyer"
                           [fieldErrors]="formValidator.formErrors"
                           [formControlRef]="convertControls('sendWhatsAppMsgAfterTrxToBuyer')"
                           [productType]="productTypeId"
                           [isUpdate]="isUpdate"></app-no-label-toggle>
    </div>
  </div>

  <div class="row align-items-center mx-0 mb-4">
    <div class="col-md-7" id="currency-label">
      <label>{{ 'Sellers.Products.ViewingCurrency' | translate }}</label>
    </div>
    <div class="col-md-5" id="currency-field">
      <app-no-label-select-list [fieldObject]="viewingCurrencyField"
                                [fieldErrors]="formValidator.formErrors"
                                [formControlRef]="convertControls('Currency')"
                                [productType]="productTypeId"
                                [isUpdate]="isUpdate"></app-no-label-select-list>
    </div>
  </div>
  <div class="row align-items-center mx-0 mb-4">
    <div class="col-md-7" id="taxes-question-label">
      <label>{{ 'Sellers.Products.ApplyTaxes' | translate: { product: 'event', productAr: 'الفعالية' } }}</label>
    </div>
    <div class="col-md-5" id="taxes-question-field">
      <app-no-label-toggle [fieldObject]="taxesQuestionField"
                           [fieldErrors]="formValidator.formErrors"
                           [formControlRef]="convertControls('TaxesQuestion')"
                           [productType]="productTypeId"
                           [isUpdate]="isUpdate"></app-no-label-toggle>
    </div>
  </div>
  <div class="row align-items-center mx-0 mb-4" *ngIf="isTaxesApplied">
    <div class="col-md-3" id="taxes-label">
      <label>{{ 'Sellers.Products.Taxes' | translate }}</label>
    </div>
    <div class="col-md-5" id="taxes-field">
      <app-taxes [fieldObject]="taxesField"
                 [fieldErrors]="formValidator.formErrors"
                 [formControlRef]="convertControls('Taxes')"
                 [productType]="productTypeId"
                 [isUpdate]="isUpdate"></app-taxes>
    </div>
  </div>
  <div class="row align-items-center mx-0 mb-4" *ngIf="isTaxesApplied">
    <div class="col-md-3" id="taxes-type-label">
      <label>{{ 'Sellers.Products.TaxesTypes' | translate }}</label>
    </div>
    <div class="col-md-5" id="taxes-type-field">
      <app-taxes-type [fieldObject]="taxesTypeField"
                      [fieldErrors]="formValidator.formErrors"
                      [formControlRef]="convertControls('Type')"
                      [productType]="productTypeId"
                      [isUpdate]="isUpdate"></app-taxes-type>
    </div>
  </div>
</div>

<div class="cardbg-white my-3">
  <div class="row align-items-center mx-0 mb-4">
    <div class="col-md-7" id="fees-question-label">
      <label>{{ 'Sellers.Products.showInEventsPage' | translate }}</label>
    </div>
    <div class="col-md-5" id="fees-question-field">
      <app-no-label-toggle [fieldObject]="showInEventsPage"
                           [fieldErrors]="formValidator.formErrors"
                           [formControlRef]="convertControls('Show your event on Easykash Events page?')"
                           [productType]="productTypeId"
                           [isUpdate]="isUpdate"></app-no-label-toggle>
    </div>
  </div>
    <div class="row align-items-center mx-0 mb-4">
      <div class="col-md-7" id="fees-question-label">
        <label>{{ 'Sellers.Products.marketingFeesEventsPage' | translate }}</label>
      </div>
      <div class="col-md-5" id="fees-question-field">
        <app-no-label-toggle [fieldObject]="marketingFeesEventsPage" [fieldErrors]="formValidator.formErrors"
          [formControlRef]="convertControls('Do you want the marketing fees to be on the buyer?')" [productType]="productTypeId"
          [isUpdate]="isUpdate"></app-no-label-toggle>
      </div>
    </div>
</div>
</form>
